/* The head of a lesson: one goal, three levels of reaching it.

   It is the first thing on the page and it does not fold. The portal used to
   teach a method for arriving at a goal; teachers already have one. What it
   owes them is the goal itself, said so plainly that a colleague could check
   it at the end of the period.

   Which pupil a level belongs to is set small and grey. It is written for the
   teacher, and the wall a class can see must never carry the words "the weaker
   pupil" beside a name.

   OWNED BY ITEM 3 OF PLAN.md. */

import { T } from "../../blocks/shared";
import { useI18n } from "../../lib/i18n";
import type { Goal as GoalType } from "../../lib/types";

export function Goal({ goal }: { goal: GoalType }) {
  const { ui } = useI18n();
  return (
    <section className="lesson-goal" id="cil">
      <div className="cat-folds-bar"><h2 className="cat-h">{ui("lesson.goal")}</h2></div>

      {goal.lead ? <p className="lesson-goal-lead"><T value={goal.lead} /></p> : null}

      <ol className="lesson-levels">
        {goal.levels.map((level) => (
          /* The expected level carries the accent: it is the one the lesson
             aims at, and the other two are what happens either side of it. */
          <li key={level.id} className={"lesson-level" + (level.id === "bezny" ? " is-aim" : "")}>
            <h3 className="lesson-level-name">{ui(`level.${level.id}`)}</h3>
            <p className="lesson-level-who"><T value={level.who} /></p>
            <p className="lesson-level-can"><T value={level.can} /></p>
            <p className="lesson-level-proof">
              <span className="lesson-label">{ui("lesson.proof")}</span>{" "}
              <T value={level.proof} />
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
}
